import _ from 'lodash'
import moment from 'moment'
import { isDateInRange } from '@utils/date-helpers'

export const state = {
  events: [],
  selectedEventId: '',
}

export const getters = {
  allEvents(state) {
    return state.events
  },

  upcomingEvents(state) {
    return _(state.events)
      .orderBy(({ start }) => moment(start, 'YYYY-MM-DD hh:mm:ss').toDate())
      .filter(({ start }) => moment(start, 'YYYY-MM-DD hh:mm:ss').isSameOrAfter(moment().startOf('day')))
      .value()
  },

  getEventsOnDate(state) {
    return (date) =>
      _(state.events)
        .orderBy(({ start }) => moment(start, 'YYYY-MM-DD hh:mm:ss').toDate())
        .filter(({ startDateObject, endDateObject }) => isDateInRange(date, startDateObject, endDateObject))
        .value()
  },

  favoriteEvents(state) {
    return state.events.filter((event) => event.isFavorite)
  },

  isEventFavorite(state, getters) {
    return (eventId) => getters.favoriteEvents.some((event) => event.eventId === eventId)
  },

  selectedEventId(state) {
    return state.selectedEventId
  },
}

export const mutations = {
  SET_EVENTS(state, events) {
    state.events = events
  },

  FAVORITE_EVENT_BY_ID(state, eventId) {
    const eventToBeFavorite = state.events.find((event) => event.eventId === eventId)
    eventToBeFavorite.isFavorite = true
    eventToBeFavorite.favoritedAt = new Date().toISOString()
  },

  UNFAVORITE_EVENT_BY_ID(state, eventId) {
    const eventToBeUnfavorite = state.events.find((event) => event.eventId === eventId)
    eventToBeUnfavorite.isFavorite = false
    eventToBeUnfavorite.favoritedAt = null
  },

  SET_SELECTED_EVENT_ID(state, eventId) {
    state.selectedEventId = eventId
  },
}
